import style from './miniCard.module.css'
import React, { useEffect, useState } from 'react'
import icons from '../../../../img/icons/icons'
import { ITrainingArea, TrainingAreaServices } from '../../../Services/api/trainingArea/TrainingArea.services';
import { IPicture, picturesServices } from '../../../Services/api/pictures/picturesServices';
import { useModal } from '../../../Contexts/Modal.context';
import { useNavigate } from 'react-router-dom';

interface IMiniCard {
    trainingAreaId: string;
    key: React.Key | null | undefined
}

export const MiniCard: React.FC <IMiniCard> = (props) =>{

    const [traningArea, setTrainingArea] = useState<ITrainingArea | null>(null);
    const NoIMG = icons.NoIMG;
    const [TrainingAreaPicture, setTrainingAreaPicture] = useState<IPicture | null>(null);
    const { setTrainingAreaIdInDestak } = useModal();
    const navigate = useNavigate();

    // get training area by id
    useEffect(() => {
        const fetchTrainingArea = async () => {
            try {
                const response = await TrainingAreaServices.getTrainingAreaById(props.trainingAreaId);
                if (!(response instanceof Error)) {
                    setTrainingArea(response);
                    if(response.PictureId){
                        const pictureResponse = await picturesServices.getPictureByID(response.PictureId);
                        if (!(pictureResponse instanceof Error)) {
                            setTrainingAreaPicture(pictureResponse);
                        } else {
                            setTrainingAreaPicture(null);
                        }
                    }
                } else {
                    setTrainingArea(null);
                }
            } catch (error) {
                console.error('Erro ao buscar área de treinamento:', error);
            }
        };
        fetchTrainingArea();
        
    }, [props.trainingAreaId]);

    const clickMiniCard = () => {
        if(traningArea){
            setTrainingAreaIdInDestak(traningArea._id);
            navigate('/cursos');
        }
    }
      
    return (
        <button type="button" className={style.Content} onClick={clickMiniCard}>
            <img src={TrainingAreaPicture ? TrainingAreaPicture.url : NoIMG} alt = ""></img>
            <span className={style.Text}>{traningArea?.Name}</span> 
        </button>
    )
}